module.exports = __webpack_public_path__ + "img/icon_3_12.d1cb55dd.png";